export default function UserReviewConstructor(REVIEW_ITEM_STATUSES) {
    'ngInject';

        const getCommentFromReview = _.flow(getUserReviewItems, findCommentInItems, _.partialRight(_.get, 'Comment'));

        function UserReview(backendUserReviewData) {
            this.createdAt = moment(backendUserReviewData.CreationDate);
            this.comment = getCommentFromReview(backendUserReviewData);
            this.userEmail = backendUserReviewData.EmailAddress;
            this.contactFullName = backendUserReviewData.ContactFullName;
            this.isReviewed = backendUserReviewData.IsReviewed;
            this.items = backendUserReviewData.TripReviewItems;
        }

        UserReview.prototype.getItemByTripItemId = getItemByTripItemId;
        UserReview.prototype.getUserIdentity = getUserIdentity;
        UserReview.prototype.isTripItemIdDeclined = isTripItemIdDeclined();
        UserReview.prototype.isTripItemIdApproved = isTripItemIdApproved();
        UserReview.prototype.isTripItemIdNotInticated = isTripItemIdNotInticated;
        UserReview.prototype.getTripItemStatusIdByTripItemId = _.flow(getItemByTripItemId, _.property('ReviewStatus'));
        return UserReview;

        function getItemByTripItemId(tripItemId) {
            return _.find(this.items, {TripItemId: tripItemId});
        }

        function isTripItemIdDeclined() {
            return _.flow(getItemByTripItemId, _.partialRight(isItemInStatus, REVIEW_ITEM_STATUSES.Declined));
        }

        function isTripItemIdApproved() {
            return _.flow(getItemByTripItemId, _.partialRight(isItemInStatus, REVIEW_ITEM_STATUSES.Approved));
        }

        function isTripItemIdNotInticated(tripItemId) {
            const item = this.getItemByTripItemId(tripItemId);
            return !item || isItemInStatus(item, REVIEW_ITEM_STATUSES.Declined);
        }

        function findCommentInItems(reviewItems) {
            return _.find(reviewItems, function(reviewItem) {
                return reviewItem.Comment !== null;
            });
        }

        function getUserReviewItems(backendUserReviewData) {
            return backendUserReviewData.TripReviewItems;
        }

        function isItemInStatus(item, status) {
            return item ? item.ReviewStatus === status : false;
        }

        function getUserIdentity() {
            return this.contactFullName ? this.contactFullName : this.userEmail;
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/services/userReviewConstructor.factory.js